export default __webpack_public_path__ + "static/10-1d0ccad5668b394a74f265301d94e7ef.svg";